export default function mark (str) {
  let result = '';

  let b = false;
  let i = false;
  for (let idx = 0; idx < str.length; idx++) {
    const char = str[idx];
    const nextChar = str[idx + 1];

    if (char === '*' && nextChar === '*') {
      b = !b;
      result += (b ? '<b>' : '</b>');
      idx++;
    } else if (char === '_' && nextChar === '_') {
      i = !i;
      result += (i ? '<i>' : '</i>');
      idx++;
    } else {
      result += char;
    }
  }

  if (b) result += '</b>';
  if (i) result += '</i>';

  return result;
}
